import React, {useMemo} from 'react';
import Form, { Assets, Hidden, ULID, Actions } from '../../Components/Form';
import Modal from '../../Components/Modal';
import API from '../../Services/API';
import { useToasts } from '../../Components/Toasts';
import Alert from '../../Components/Alert';
import Button from '../../Components/Button/Button';
import { useSettings } from '../../Data/Settings';

const NewImport = ({isOpen, setIsOpen, onNewImport}) => {
    const {settings} = useSettings('/notifications/settings');

    const notificationsOn = useMemo(() => {
        if (!settings) {
            return null;
        };

        const relevant = [
            'Notifications:SendCustomerJobBecameToday',
            'Notifications:SendCustomerJobDueWeekUpdated',
            'Notifications:SendCustomerJobMarkedAsDone',
            'Notifications:SendCustomerJobSkipped',
            'Notifications:SendCustomerJobScheduled',
            'Notifications:SendCustomerMessageSent',
            'Notifications:SendCustomerInvoiceBecameOverdue',
            'Notifications:SendCustomerWelcome',
            // 'Notifications:SendCustomerPortalLink',
        ]

        return settings.filter(setting => relevant.includes(setting.key)).some(setting => setting.value !== 'None');
    }, [settings]);

    return <Modal title="Import" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{onNewImport, notificationsOn}} />}
    </Modal>
}

const Inner = ({onNewImport, notificationsOn}) => {
    const {showError, showSuccess} = useToasts();


    const handleSubmit = async (data) => {
        return API.post('/imports', data).then(() => {
            onNewImport && onNewImport(data.importId);
            showSuccess('Import started');
        }).catch(err => showError(API.parseErrorResponse(err)));
    }

    return <Form onSubmit={handleSubmit} closeModalOnSubmit>
        <ULID name="importId" />
        <Hidden name="type" value="CSV_AI" />

        {notificationsOn === true && <Alert theme="warning"
            title="Customer notifications"
            message="You have some customer notifications turned on, so your customers may receive emails or SMS as they are imported."
            buttons={[
                <Button key="dismiss" theme="warning" label="Notification settings" link="/settings/customer-notifications" />
            ]}
        />}
        {notificationsOn === false && <Alert theme="info"
            title="Customer notifications"
            message="You have no customer notifications turned on. Your customers will not receive any emails or SMS as they are imported."
            buttons={[
                <Button key="dismiss" theme="info" label="Notification settings" link="/settings/customer-notifications" />
            ]}
        />}
        {notificationsOn === null && <Alert theme="info"
            loading={true}
            title="Customer notifications"
            message="Checking your notification settings."
        />}

        <Assets name="assetId" label="Select a CSV file" single tags={[{name: 'Import', value: 'Import'}]} accept="text/csv" />
        <Actions submit={{label: 'Import'}} cancel />
    </Form>
}

export default NewImport;
